(function () {
  "use strict";
  /* Wade Greens - make the hero video actually autoplay.

     sections/slide-show.liquid renders both hero videos with preload="none"
     AND autoplay, which contradict each other: preload="none" tells the
     browser not to fetch, so iOS finds nothing buffered when it goes to
     satisfy autoplay, gives up, and paints the play control. That section is
     196KB, over the API write ceiling, so it is corrected here at runtime.

     This script only ever ENABLES playback. It never removes an attribute,
     never adds `poster` or `controls`, and never pauses anything.

     WHAT IT CANNOT FIX
     iOS Low Power Mode blocks autoplay outright, as does Settings > Safari >
     Auto-Play set to "Never Auto-Play". No markup defeats either one. Both do
     allow playback after a user gesture, which is why the first touch, scroll
     or keypress retries. Those listeners are `once` and remove themselves.

     The permanent fix is one word in the theme: preload="none" ->
     preload="auto" on the two <video> tags in sections/slide-show.liquid, in
     the Shopify code editor. Once that is done this file can be deleted. */

  function start(v) {
    if (!v.hasAttribute("autoplay")) return;
    if (v.getAttribute("preload") === "none") {
      v.setAttribute("preload", "auto");
      try { v.load(); } catch (e) {}
    }
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function sweep() {
    var vids = document.querySelectorAll("video[autoplay]");
    for (var i = 0; i < vids.length; i++) start(vids[i]);
  }

  function init() {
    sweep();

    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) sweep();
    });

    document.addEventListener("shopify:section:load", function () {
      window.setTimeout(sweep, 60);
    });

    var gestures = ["touchstart", "pointerdown", "scroll", "keydown"];
    function onGesture() {
      sweep();
      for (var i = 0; i < gestures.length; i++) {
        window.removeEventListener(gestures[i], onGesture, true);
      }
    }
    for (var i = 0; i < gestures.length; i++) {
      window.addEventListener(gestures[i], onGesture, { capture: true, passive: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
